import { Dispatch, FC, SetStateAction, useState } from "react";
import { ButtonContentNew, ButtonContentTextNew, ButtonNew, ButtonsContainerNew, ButtonsWrapperNew, ButtonTitleNew, HeaderNew, TitleMainNew, WrapperNew } from "./styled";
import { useTranslation } from "react-i18next";
import { configForAll, ConfigItem } from "../utils/config";


interface AddPhotoMobileProps {
    closeWidgetLoginModal: () => void,
    setControlButtons: Dispatch<SetStateAction<boolean>>
}

export const AddPhotoControlNew : FC<AddPhotoMobileProps> = ({ closeWidgetLoginModal, setControlButtons })=> {
    const [isForMe, setForMe] = useState(false);
    const { t } = useTranslation();
    const [isLoadingAnimation, setLoadingAnimation] = useState(false);
    const [isPressedButton, setPressedButton] = useState('');
    const handleButtonClick = (item: ConfigItem, link: string) => (e: React.MouseEvent) => {
        e.stopPropagation();
        e.preventDefault();
        item.isForMe ? setForMe(true) : setForMe(false)
        setPressedButton(item.dataAttribute);
        window.open(item.link, '_blank');
        setPressedButton('');
        // setControlButtons(false)
        // closeWidgetLoginModal()
        return;
    };

    const renderButtons = (config: ConfigItem[]) => 
        config.map((item) => {
            const IconComponent = item.icon;
                return (
                    <ButtonNew
                        key={item.dataAttribute}
                        onClick={handleButtonClick(item, item.link)}
                        data-control={item.dataAttribute}
                        // disabled={disabled}
                    >
                        <ButtonContentNew>
                            <div className="content_wrapper"><IconComponent /><ButtonTitleNew>{t(item.title)}</ButtonTitleNew></div>
                            <ButtonContentTextNew>{t(item.smallText)}</ButtonContentTextNew>
                        </ButtonContentNew>
                    </ButtonNew>
                );});

    return (
    //    isLoadingAnimation ? <MobileLoadingScreen pressedButton={isPressedButton} isForMe={isForMe}></MobileLoadingScreen> : 
    <WrapperNew>
        <HeaderNew>
            <TitleMainNew>{t('add_photo_controll.title_main')}</TitleMainNew>
            {/* <SubTitleMainNew>{t('add_photo_controll.subtitle_main')}</SubTitleMainNew> */}
        </HeaderNew>
        <ButtonsContainerNew onClick={(event?: React.MouseEvent) => {
                 if (event) {
                    event.stopPropagation();
                    event.preventDefault();
                }
                return}} active={true}>
                <ButtonsWrapperNew>{renderButtons(configForAll)}</ButtonsWrapperNew>
        </ButtonsContainerNew>
    </WrapperNew>
    )
}import { Dispatch, FC, SetStateAction, useState } from "react";
import { ButtonContentNew, ButtonContentTextNew, ButtonNew, ButtonsContainerNew, ButtonsWrapperNew, ButtonTitleNew, HeaderNew, TitleMainNew, WrapperNew } from "./styled";
import { useTranslation } from "react-i18next";
import { configForAll, ConfigItem } from "../utils/config";


interface AddPhotoMobileProps {
    closeWidgetLoginModal: () => void,
    setControlButtons: Dispatch<SetStateAction<boolean>>
}

export const AddPhotoControlNew : FC<AddPhotoMobileProps> = ({ closeWidgetLoginModal, setControlButtons })=> {
    const [isForMe, setForMe] = useState(false);
    const { t } = useTranslation();
    const [isLoadingAnimation, setLoadingAnimation] = useState(false);
    const [isPressedButton, setPressedButton] = useState('');
    const handleButtonClick = (item: ConfigItem, link: string) => (e: React.MouseEvent) => {
        e.stopPropagation();
        e.preventDefault();
        item.isForMe ? setForMe(true) : setForMe(false)
        setPressedButton(item.dataAttribute);
        window.open(item.link, '_blank');
        setPressedButton('');
        // setControlButtons(false)
        // closeWidgetLoginModal()
        return;
    };

    const renderButtons = (config: ConfigItem[]) => 
        config.map((item) => {
            const IconComponent = item.icon;
                return (
                    <ButtonNew
                        key={item.dataAttribute}
                        onClick={handleButtonClick(item, item.link)}
                        data-control={item.dataAttribute}
                        // disabled={disabled}
                    >
                        <ButtonContentNew>
                            <div className="content_wrapper"><IconComponent /><ButtonTitleNew>{t(item.title)}</ButtonTitleNew></div>
                            <ButtonContentTextNew>{t(item.smallText)}</ButtonContentTextNew>
                        </ButtonContentNew>
                    </ButtonNew>
                );});

    return (
    //    isLoadingAnimation ? <MobileLoadingScreen pressedButton={isPressedButton} isForMe={isForMe}></MobileLoadingScreen> : 
    <WrapperNew>
        <HeaderNew>
            <TitleMainNew>{t('add_photo_controll.title_main')}</TitleMainNew>
            {/* <SubTitleMainNew>{t('add_photo_controll.subtitle_main')}</SubTitleMainNew> */}
        </HeaderNew>
        <ButtonsContainerNew onClick={(event?: React.MouseEvent) => {
                 if (event) {
                    event.stopPropagation();
                    event.preventDefault();
                }
                return}} active={true}>
                <ButtonsWrapperNew>{renderButtons(configForAll)}</ButtonsWrapperNew>
        </ButtonsContainerNew>
    </WrapperNew>
    )
}